import axios, { AxiosProgressEvent } from 'axios';
import getConfig from 'next/config';

import { HEADERS } from '@sravni/server-utils/lib/consts';
import logger from '@sravni/server-utils/lib/logger';

import { IFile } from '../interfaces/files';
import { IAttachmentParams } from '../interfaces/reviews';

import ProxyClient from './clients/ProxyClient';

export const uploadFile = async (file: File, onLoadProgress?: (p: AxiosProgressEvent) => void): Promise<IFile> => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  try {
    const result = await axios.post(`${getConfig().publicRuntimeConfig.apiPath}/files/upload`, payload, {
      onUploadProgress: onLoadProgress,
      headers: {
        // https://github.com/sravni/package-server-utils/blob/v0.4.0-beta.33/src/request/request.ts#L28
        ...(process.env.SERVICE_NAME ? { [HEADERS.CALLER_ID]: process.env.SERVICE_NAME } : {}),
      },
    });
    return result.data;
  } catch (error) {
    const url = error.response && error.response.config.url;

    logger.error({
      context: 'File upload',
      message: 'Failed to upload file',
      request_url: url,
      exception: {
        message: error.message,
        stack: error.stack,
      },
    });

    throw new Error(error.toJSON());
  }
};

export const loadFileInfo = async (id: string) => {
  const { data } = await ProxyClient.get<IFile>(`/files/${id}`);
  return data;
};

export const downloadFile = async (params: IAttachmentParams) => {
  const { data, headers } = await ProxyClient.get(`/reviews/${params.reviewId}/file/${params.fileId}`, {
    responseType: 'blob',
  });

  const fileName = headers['content-disposition'].split(/filename=/)[1].split(';')[0];

  return { file: data, fileName };
};
